// extracted by mini-css-extract-plugin
module.exports = {"profile__personal-data":"_3XG19Eu6","profile__personalData":"_3XG19Eu6","card-section":"_3Ww928zn","cardSection":"_3Ww928zn","delete":"_1wJv66-2","card":"_2Q1ibmIN"};